const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function resolveImageUrl(url) {
  if (!url) return null;
  // Already a full URL (http/https) — return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  // Relative path like /api/images/xxx — prepend backend URL
  return `${BACKEND_URL}${url}`;
}


export const PLACEHOLDER = "data:image/svg+xml;utf8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="400" height="500"><rect width="100%" height="100%" fill="#121212"/><text x="50%" y="50%" font-family="Arial" font-size="48" font-weight="bold" fill="#333" text-anchor="middle" dominant-baseline="middle">OYB</text></svg>');
